import React from 'react';
import CountUp from 'react-countup';
import { 
  FaChartLine, 
  FaUsers, 
  FaShoppingCart, 
  FaMoneyBillWave,
  FaProjectDiagram
} from 'react-icons/fa';

function StatCard({ 
  label, 
  value, 
  type = 'primary', 
  icon: IconComponent, 
  change, 
  changeType = 'positive',
  subtext,
  onClick 
}) {
  const getDefaultIcon = () => {
    switch(type) {
      case 'secondary': return <FaChartLine />;
      case 'warning': return <FaShoppingCart />;
      case 'danger': return <FaMoneyBillWave />;
      case 'info': return <FaUsers />;
      case 'primary':
      default: return <FaProjectDiagram />;
    }
  };

  const icon = IconComponent ? <IconComponent /> : getDefaultIcon();

  return (
    <div 
      className={`stat-card ${type}`}
      onClick={onClick}
      role={onClick ? "button" : "presentation"}
      tabIndex={onClick ? 0 : -1}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick?.()}
    >
      <div className="stat-card__top">
        <div className="stat-card__label">{label}</div>
        <div className="stat-card__icon">
          {icon}
        </div>
      </div>
      
      <div className="stat-card__value">
        <CountUp 
          end={value} 
          duration={2.5} 
          separator=","
          decimals={0}
        />
      </div>
      
      {(change || subtext) && (
        <div className="flex items-center justify-between mt-4">
          {change && (
            <div className={`stat-card__change ${changeType}`}>
              {changeType === 'positive' ? '↗' : '↘'} {change}%
            </div>
          )}
          
          {subtext && (
            <div className="stat-card__subtext">
              {subtext}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default StatCard;
